<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    created(){
        this.$store.dispatch('serviceTime')
        if (this.$route.query.lang && this.$route.query.lang == 'ko') {
            this.$store.commit('setLanguage', this.$route.query.lang)
        } else {
            this.$store.commit('setLanguage', 'cn')
        }
    }
};
</script>
<style src="@/assets/common/style.css"></style>
<style scoped>

.pc-only {
    display: block;
}

.mobile-only {
    display: none;
}

@media (max-width: 720px) {
    
    .pc-only {
        display: none;
    }

    .mobile-only {
        display: block;
    }
}
</style>
